<script lang="ts">
  import LL from '$i18n/i18n-svelte';
  import { idToItem } from '$lib/er/item/stores';
  import { getItemName } from './translation';

  export let id: number;
  export let size: 3 | 4 | 5 | 6 | 8 = 5;
  export let square = false;

  $: grade = $idToItem.get(id)?.gradeId ?? 'C';
</script>

<div class="raw-item-image" data-grade={grade} data-size={size} data-square={square}>
  <img
    alt={getItemName($LL, id)}
    src="/images/items/{id}.webp"
    height={size * (30 / 5) - 8}
    loading="lazy"
  />
</div>

<style lang="postcss">
  .raw-item-image {
    display: flex;
    place-items: center;
    place-content: center;
    border: 1px solid var(--border-item-common);
    background: var(--gradient-item-common);
    aspect-ratio: 5 / 3;
    padding: var(--space-2);

    &[data-grade='C'] {
      border: 1px solid var(--border-item-common);
      background: var(--gradient-item-common);
    }

    &[data-grade='U'] {
      border: 1px solid var(--border-item-uncommon);
      background: var(--gradient-item-uncommon);
    }

    &[data-grade='R'] {
      border: 1px solid var(--border-item-rare);
      background: var(--gradient-item-rare);
    }

    &[data-grade='E'] {
      border: 1px solid var(--border-item-epic);
      background: var(--gradient-item-epic);
    }

    &[data-grade='L'] {
      border: 1px solid var(--border-item-legendary);
      background: var(--gradient-item-legendary);
    }

    &[data-grade='M'] {
      border: 1px solid var(--border-item-mythic);
      background: var(--gradient-item-mythic);
    }

    &[data-size='8'] {
      width: 8rem;
      height: 5rem;

      &[data-square='true'] {
        height: 8rem;
      }
    }

    &[data-size='6'] {
      width: 6rem;
      height: 3.6rem;

      &[data-square='true'] {
        height: 6rem;
      }
    }

    &[data-size='5'] {
      width: 5rem;
      height: 3rem;

      &[data-square='true'] {
        height: 5rem;
      }
    }

    &[data-size='4'] {
      width: 4rem;
      height: 2.5rem;

      &[data-square='true'] {
        height: 4rem;
      }
    }

    &[data-size='3'] {
      width: 3rem;
      height: 1.8rem;

      &[data-square='true'] {
        height: 3rem;
      }
    }
  }

  img {
    object-fit: contain;
  }
</style>
